firebird.factory('videoOnScreenService', [
    '$timeout',
    '$window',
    'logService',
    'helperService',
    'configService',
    'videoFilterService',
    'videoGlobalService',
    function ($timeout, $window, logService, helperService, configService, videoFilterService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoOnScreenService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // whether to show self video on shared screen in electron app
            self.videoOnScreen = false;
            self.videoOnScreenData = {
                type: '',
                window: null,
                stream: null,
                timeout: 1000,
                position: 'bottom-left', // top-right, etc.
                dragging: false,
                face: { width: 320, height: 180 },
                circle: { size: 200, padding: 10 },
                frameRate: 15 // screen framerate to be applied if enabled.
            };

            self.initVideoOnScreen = initVideoOnScreen;
            self.onShowHideVideoOnScreen = onShowHideVideoOnScreen;
            self.onResizeVideoOnScreen = onResizeVideoOnScreen;
            self.onMoveVideoOnScreen = onMoveVideoOnScreen;
            self.onDragVideoOnScreen = onDragVideoOnScreen;
            self.videoOnScreenStart = videoOnScreenStart;
            self.videoOnScreenStop = videoOnScreenStop;
            self.onVideoOnScreenShareStream = onVideoOnScreenShareStream;
        }

        // update from config
        function initVideoOnScreen() {
            self.videoOnScreen = configService.getClientValue('videoOnScreen') == 'true';
        }

        function onShowHideVideoOnScreen(type) {
            if (!self.videoOnScreen || !helperService.isElectron()) {
                logger.warn(
                    'onShowHideVideoOnScreen',
                    'videoOnScreen feature is not enabled or available only on electron'
                );
                self.showAlert(
                    'Video Failed',
                    !self.videoOnScreen
                        ? 'The video-on-screen feature is not enabled. Please enable it from Labs Playground.'
                        : 'The video-on-screen feature is available only on native Unite or Camaro application, not from the browser.'
                );
                return;
            }

            var data = self.videoOnScreenData;
            var oldType = data.type;
            if (data.window) {
                self.videoOnScreenStop();
                data.type = '';
            }
            if (type != oldType) {
                data.type = type || '';
                self.videoOnScreenStart();
            }
        }

        function onResizeVideoOnScreen(ratio) {
            if (!self.videoOnScreen || !helperService.isElectron() || !self.videoOnScreenData.window) {
                logger.warn(
                    'onResizeVideoOnScreen',
                    'videoOnScreen feature is not enabled or available only on electron'
                );
                self.showAlert(
                    'Resize Failed',
                    !self.videoOnScreen
                        ? 'The video-on-screen feature is not enabled. Please enable it from Labs Playground.'
                        : !self.videoOnScreenData.window
                        ? 'The video-on-screen window is not yet open. Please click on the circle or face link to open it first.'
                        : 'The video-on-screen feature is available only on native Unite or Camaro application, not from the browser.'
                );
                return;
            }

            var data = self.videoOnScreenData;
            logService.log('videoroomCtrl - video-on-screen resize ratio=' + ratio);
            var w = data.window.outerWidth,
                h = data.window.outerHeight,
                x = data.window.screenLeft,
                y = data.window.screenTop;
            var cx = x + w / 2,
                cy = y + h / 2; // center
            var W = $window.screen.width,
                H = $window.screen.height;
            var w1 = Math.round(w * ratio),
                h1 = Math.round(h * ratio);
            var x1 = x,
                y1 = y;
            if (cx > W / 2) {
                // maintain right offset
                x1 -= w1 - w;
            }
            if (cy > H / 2) {
                y1 -= h1 - h;
            }
            if (x1 != x || y1 != y) {
                data.window.moveTo(x1, y1);
            }
            data.window.resizeTo(w1, h1);
        }

        function onMoveVideoOnScreen() {
            if (!self.videoOnScreen || !helperService.isElectron() || !self.videoOnScreenData.window) {
                logger.warn(
                    'onMoveVideoOnScreen',
                    'videoOnScreen feature is not enabled or available only on electron'
                );
                self.showAlert(
                    'Move Failed',
                    !self.videoOnScreen
                        ? 'The video-on-screen feature is not enabled. Please enable it from Labs Playground.'
                        : !self.videoOnScreenData.window
                        ? 'The video-on-screen window is not yet open. Please click on the circle or face link to open it first.'
                        : 'The video-on-screen feature is available only on native Unite or Camaro application, not from the browser.'
                );
                return;
            }

            var data = self.videoOnScreenData;
            var previous = data.position;
            var positions = ['bottom-left', 'bottom-right', 'top-right', 'top-left'];
            var index = positions.indexOf(previous);
            var next = positions[(index + 1) % positions.length];
            data.position = next;

            logService.log('videoroomCtrl - video-on-screen move ' + previous + ' => ' + next);

            var width = data.window.outerWidth,
                height = data.window.outerHeight;
            var left = 0,
                top = ($window.screen && $window.screen.availTop) || 0;
            if (next.startsWith('bottom-')) {
                top =
                    $window.screen && $window.screen.availHeight
                        ? $window.screen.availHeight + $window.screen.availTop - height
                        : 0;
            }
            if (next.endsWith('-right')) {
                left = $window.screen && $window.screen.availWidth ? $window.screen.availWidth - width : 0;
            }
            data.window.moveTo(left, top);
        }

        function onDragVideoOnScreen() {
            if (!self.videoOnScreen || !helperService.isElectron() || !self.videoOnScreenData.window) {
                return;
            }

            var data = self.videoOnScreenData;
            data.dragging = !data.dragging;
            logService.log('videoroomCtrl - video-on-screen dragging=' + data.dragging);
            if (data.dragging) {
                data.window.document.querySelector('body').setAttribute('dragging', 'true');
            } else {
                data.window.document.querySelector('body').removeAttribute('dragging');
            }

            $window.preloadedApi.remote.ipcRenderer.sendChildNoMouse({ value: !data.dragging });
        }

        function videoOnScreenStart() {
            if (!self.videoOnScreen) {
                return;
            }
            var data = self.videoOnScreenData;
            // for circle (not-face) use same width and height
            var position = {
                width: data.type == 'face' ? data.face.width : data.circle.size,
                height: data.type == 'face' ? data.face.height : data.circle.size
            };
            data.position = 'bottom-left';
            position.left = 0;
            position.top =
                $window.screen && $window.screen.availHeight
                    ? $window.screen.availHeight + $window.screen.availTop - position.height
                    : 0;
            logService.log(
                'videoroomCtrl - video-on-screen start type=' + data.type + ' position=' + JSON.stringify(position)
            );
            var child = (data.window = window.open(
                '',
                'transparent:child:nomouse:top',
                'width=' +
                    position.width +
                    ',height=' +
                    position.height +
                    ',left=' +
                    position.left +
                    ',top=' +
                    position.top
            ));

            $timeout(function () {
                // why do we need a timer?

                // note a blur of 3px used in videoFilter logic, so div is expanded to avoid showing blurry edges.
                var head =
                    '<style type="text/css">\n' +
                    'body { padding: 0; margin: 0; -webkit-app-region: drag; background-color: #00000000; user-select: none; }\n' +
                    'div { position: absolute; width: 102%; height: 102%; left: -1%; top: -1%; overflow: hidden; }\n' +
                    'body:not([dragging]) div:hover { opacity: 0; transition: opacity 0.3s; }\n' +
                    'video { position: absolute; width: 100%; height: 100%; object-fit: cover; -webkit-app-region: drag; }\n' +
                    '</style>\n';
                child.document.head.innerHTML = head;
                var body = '<div><video autoplay muted /></div>';
                child.document.body.innerHTML = body;

                if (data.type == 'face') {
                    // this will interfere with videoFilter checkbox.
                    var stream = (self.videoOnScreenData.stream = videoFilterService.startVideoFilterStream(
                        self.getMediaConstraints,
                        { value: 'transparent-bg' }
                    ));
                    child.document.querySelector('video').srcObject = stream;
                } else {
                    var width = data.circle.size - 2 * data.circle.padding;
                    child.document
                        .querySelector('div')
                        .setAttribute(
                            'style',
                            'position: relative; width: calc(100% - 20px); height: calc(100% - 20px);' +
                                ' margin: ' +
                                data.circle.padding +
                                'px; border-radius: 50%; box-shadow: 0 0 10px 1px rgba(0,0,0,0.3);'
                        );

                    var media = self.getMediaConstraints('video-filter'); // will include deviceId if needed.
                    navigator.mediaDevices
                        .getUserMedia(media)
                        .then(function (stream) {
                            self.videoOnScreenData.stream = stream;
                            stream.getVideoTracks()[0].contentHint = 'motion';
                            child.document.querySelector('video').srcObject = stream;
                        })
                        .catch(function (error) {
                            logger.error('videoOnScreenStart', 'failed to get user media', error);
                        });
                }

                if (self.screenstream) {
                    self.onVideoOnScreenShareStream(self.screenstream);
                }
            }, data.timeout);
        }

        function onVideoOnScreenShareStream(stream) {
            if (stream) {
                var data = self.videoOnScreenData;
                try {
                    logService.log(
                        'videoroomCtrl - changing screen publish framerate to ' +
                            data.frameRate +
                            ' because of video-on-screen'
                    );
                    stream.getVideoTracks()[0].applyConstraints({ frameRate: data.frameRate });
                } catch (e) {
                    logger.error(
                        'onVideoOnScreenShareStream',
                        'failed to change screen share framerate for video-on-screen',
                        e
                    );
                }
            }
        }

        function videoOnScreenStop() {
            if (!self.videoOnScreen) {
                return;
            }

            var data = self.videoOnScreenData;
            logService.log(
                'videoroomCtrl - video-on-screen stop type=' +
                    data.type +
                    ' stream=' +
                    !!data.stream +
                    ' window=' +
                    !!data.window
            );
            if (data.stream) {
                if (data.type == 'face') {
                    videoFilterService.stopVideoFilterStream();
                }
                try {
                    data.stream.getVideoTracks()[0].stop();
                } catch (e) {}
                data.stream = null;
            }
            if (data.window) {
                data.window.close();
                data.window = null;
            }
        }
    }
]);
